import { render } from "./BaseTabPanel.vue?vue&type=template&id=f493d2fc&scoped=true"
import script from "./BaseTabPanel.vue?vue&type=script&lang=js"
export * from "./BaseTabPanel.vue?vue&type=script&lang=js"

import "./BaseTabPanel.vue?vue&type=style&index=0&id=f493d2fc&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f493d2fc"]])

export default __exports__